import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse, DocumentTemplate } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useDocumentTemplateDelete() {
  return useMutationWithValidation({
    mutationFn: async (id: string) => {
      const response = await axiosInstance({
        method: "DELETE",
        url:  `DocumentTemplate/Delete/${id}`,
      });

      return response?.data as DataAwareResponse<DocumentTemplate>;
    },
    retry: 2,
  });
}
